module.exports = __webpack_public_path__ + "v4assets/browser_agent_icon.19740a38405f0f44536ae3b3347c3f9b.png";